import { IFiscalPeriodQuarter } from "types/graphqlTypes";

export default function getFiscalQuarterText(fiscalQuarter: IFiscalPeriodQuarter) {
  if (fiscalQuarter === IFiscalPeriodQuarter.Q1) {
    return "1º trimestre";
  }
  if (fiscalQuarter === IFiscalPeriodQuarter.Q2) {
    return "2º trimestre";
  }
  if (fiscalQuarter === IFiscalPeriodQuarter.Q3) {
    return "3º trimestre";
  }
  return "4º trimestre";
}
